import { Pagination } from '@/domain/entities/Pagination'

export class MasterCarData {
  private id: number
  private name: string
  private tag: string
  private trainingStatus: boolean
  private sopStatus: boolean
  private imageThumbnail: string
  private imageCover: string
  private imageLogo: string
  private createdAt: string
  private updatedAt: string

  constructor(
    id: number,
    name: string,
    tag: string,
    trainingStatus: boolean,
    sopStatus: boolean,
    imageThumbnail: string,
    imageCover: string,
    imageLogo: string,
    createdAt: string,
    updatedAt: string
  ) {
    this.id = id
    this.name = name
    this.tag = tag
    this.trainingStatus = trainingStatus
    this.sopStatus = sopStatus
    this.imageThumbnail = imageThumbnail
    this.imageCover = imageCover
    this.imageLogo = imageLogo
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }
}

export class MasterCar {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: MasterCarData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: MasterCarData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
